import { createSlice } from "@reduxjs/toolkit";
import editTeleModPrice from "../../../rtk-apis/Setting/editTeleModPrice";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const editTeleModPriceSlice = createSlice({
    name: "editTeleModPriceSlice",
    initialState,
    reducers: {
        clearEditTeleModPriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(editTeleModPrice.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(editTeleModPrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(editTeleModPrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default editTeleModPriceSlice.reducer;
export const { clearEditTeleModPriceState } = editTeleModPriceSlice.actions;
